import { render, staticRenderFns } from "./StudentBlacklist.vue?vue&type=template&id=c938f39e&"
import script from "./StudentBlacklist.vue?vue&type=script&lang=js&"
export * from "./StudentBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports